module.exports = __webpack_public_path__ + "img/9.4e0bf62.png";